export default __webpack_public_path__ + "static/media/thunderstorms.8dc8f84c.svg";